import { useDashboard } from '../dashboard.provider'
import DashboardPatientMedEventOverview from './dashboard-patient-medevent-overview.component'
import DashboardMedicalTeamComment from './dashboard-medical-team-comment.component'
import { useQuery } from '@tanstack/react-query'
import { DashboardService } from 'src/services/dashboard.service'
import { useTranslation } from 'react-i18next'
import DashboardSmsLog from './dashboard-sms-log.component'
import { useParams } from 'react-router'

const DashboardSelectedPatientMedEvent = () => {
  const { t } = useTranslation()
  const { projectId } = useParams()
  const projectIdNum = Number(projectId)
  const { selectedPatientMedEvent } = useDashboard()
  const selectedPatientMedEventId = Number(selectedPatientMedEvent?.id)
  const selectedPatientId = Number(selectedPatientMedEvent?.Patient?.id)

  const {
    isLoading: isPatientMedEventOverviewLoading,
    isError: isPatientMedEventOverviewError,
    data: dashboardPatientOverview,
  } = useQuery({
    queryKey: ['dashboard-patient-med-event', selectedPatientMedEventId],
    queryFn: () =>
      DashboardService.getDashboardPatient(projectIdNum, selectedPatientId, selectedPatientMedEventId),
    enabled: !!selectedPatientId && !!projectIdNum && !!selectedPatientMedEventId,
  })

  if (isPatientMedEventOverviewError) {
    return (
      <div className="c-min-h-[200px] c-p-6 c-flex c-items-center c-justify-center c-text-lg">
        {t('pages.dashboard.an-error-occured')}
      </div>
    )
  }

  if (isPatientMedEventOverviewLoading || !dashboardPatientOverview) {
    return (
      <div className="c-w-full c-p-6 c-flex c-items-center c-justify-center c-text-lg">
        {t('pages.dashboard.thanks-to-wait')}
      </div>
    )
  }

  return (
    <div className="c-w-full c-px-8 c-pt-4 c-flex-col c-flex-grow c-flex c-gap-6 c-border-l c-border-l-grey-200 c-overflow-scroll">
      <DashboardPatientMedEventOverview dashboardPatientOverview={dashboardPatientOverview} />
      {dashboardPatientOverview?.smsLog && <DashboardSmsLog smsLog={dashboardPatientOverview.smsLog} />}
      <DashboardMedicalTeamComment medicalTeamComments={dashboardPatientOverview.medicalTeamComments} />
    </div>
  )
}

export default DashboardSelectedPatientMedEvent
